import styled from 'styled-components';

import { Box } from 'components/Box';
import { SecondaryButton } from 'components/Button';
import { Text } from 'components/Text/Text';
import { transition } from 'theme';

const StyledSecondaryButton = styled(SecondaryButton)`
  && {
    background: white;
    &:hover,
    &:focus {
      background: white;
    }
  }
`;

type Props = {
  showAll: boolean;
  toggle: () => void;
};

export function CmsGradFairGradProgramLinksBlockToggleButton({
  showAll,
  toggle,
}: Props) {
  return (
    <StyledSecondaryButton onClick={toggle} data-qa-id="toggle-programs">
      <Box component="span" mr="8px" whiteSpace="noWrap">
        {showAll ? getText('Show fewer') : getText('Show all')}
      </Box>

      <Box
        transform={showAll ? 'translateY(-9%)' : 'rotate(-90deg)'}
        transition={`transform ${transition}`}
        display="inline-block"
        verticalAlign="middle"
      >
        <Text styleAs="h4" lineHeight="1">
          {showAll ? '–' : '+'}
        </Text>
      </Box>
    </StyledSecondaryButton>
  );
}
